import { render, staticRenderFns } from "./EnableBetting.vue?vue&type=template&id=6069f938"
import script from "./EnableBetting.vue?vue&type=script&lang=js"
export * from "./EnableBetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports